import { gql } from '@apollo/client'
import money from '~/graphql/fragments/money'

export const ticketAlertFragment = gql`
  fragment ticketAlert on TicketAlert {
    id
    event {
      id
      slug
      name
      ticketAlertsCount
      isPopular
      types(first: 99) {
        edges {
          node {
            id
            title
          }
        }
      }
    }
    eventType {
      id
      title
      slug
      ticketAlertsCount
      isPopular
    }
    maximumPrice {
      ...money
    }
  }

  ${money}
`
